import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import "react-datepicker/dist/react-datepicker.css";
import { Alert } from "react-bootstrap";
import { AdminAssignPlacementListDTO } from "../../types/NotificationTypes";
import moment from "moment";
import Spinner from "../../../features/Spinner/Spinner";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import Datetime from "react-datetime";
import { PlacementExamAPI } from "../../apis/PlacementExamAPI";

export const AssignPlacementExam = (props: any) => {
  const role = Cookies.get("role");
  const [wait, setWait] = useState<boolean>(false);

  const [placementExamDate, setPlacementExamDate] = useState<Date>();
  const [placementExamLoacation, setPlacementExamLocation] = useState<string>();
  const { handleSubmit } = useForm<AdminAssignPlacementListDTO>();

  const onSubmit: SubmitHandler<AdminAssignPlacementListDTO> = async (data) => {
    setWait(true);
    const placementexam = new PlacementExamAPI();
    const res = await placementexam.AssignPlacementExam({
      listOfApplicants: props.listOfApplicants,
      examTime: moment(placementExamDate).local().toDate(),
      location: placementExamLoacation,
    });
    toast.success("Assigned successfully!");
    setWait(false);
    setPlacementExamDate(new Date());
    setPlacementExamLocation("");

    await props.updateList();
  };
  return (
    <div>
      {!["ADM", "AVP", "ENG"].includes(role ?? "") ? (
        <span>You don't have a permission</span>
      ) : (
        <div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <Alert variant="warning">
                <h4>
                  Would you like to assign{" "}
                  <strong>{props.listOfApplicants.length}</strong> applicants
                  for a placement exam?
                </h4>
              </Alert>
            </div>
            <h3></h3>
            <div>
              <span>Select a date and time: </span>
              <Datetime
                onChange={(date) => {
                  if (typeof date !== "string") {
                    setPlacementExamDate(date.toDate());
                  }
                }}
                value={placementExamDate}
                dateFormat="DD/MM/YYYY"
              />
            </div>
            <div>
              <span>Location:</span>
              <input
                type="text"
                value={placementExamLoacation}
                onChange={(e) => setPlacementExamLocation(e.target.value)}
              />
            </div>
            {props.listOfApplicants.length > 0 ? (
              <div>
                {wait ? (
                  <Spinner />
                ) : (
                  <button className="btn" type="submit">
                    Assign
                  </button>
                )}
              </div>
            ) : null}
          </form>
        </div>
      )}
    </div>
  );
};
